import React from 'react';
import ringArt from '../../assets/img/portal-ring.png';
import './clubsMotion.css';

/**
 * The Portal ring as a mark: the swirl turning behind something round — a live club's avatar in
 * the CLUB PORTAL LIVE pill, the cyan beacon on the City Portal room, a + on START YOUR OWN CLUB.
 *
 * components/stories/PortalRing is the rail's ring and carries the story states (unseen, live,
 * seen, send) with it; this is the art alone, at the sizes, speeds and ripple staggers the clubs
 * handoff asks for, so neither has to bend to fit the other.
 *
 *   ripples  delays in seconds, one ring each, all on the handoff's 3.6s cycle
 *   spin     seconds per turn; `ccw` turns it the other way
 *   inset    how far the face sits inside the band (px, or a % string)
 */
export default function RingMark({
  size = 32,
  spin = 6,
  direction = 'cw',
  ripples = [],
  rippleColor = '#00FFFF',
  inset = 3,
  faceBackground = '#fff',
  children,
  style,
}) {
  const pad = typeof inset === 'number' ? `${inset}px` : inset;
  return (
    <span aria-hidden="true" style={{ position: 'relative', flexShrink: 0, width: size, height: size, display: 'block', ...style }}>
      {ripples.map((delay) => (
        <span
          key={delay}
          data-clb-motion
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            border: `2px solid ${rippleColor}`,
            animation: `clbRipple 3.6s cubic-bezier(0,0,.2,1) ${delay}s infinite both`,
          }}
        />
      ))}
      <span
        data-clb-motion
        style={{
          position: 'absolute',
          inset: 0,
          borderRadius: '50%',
          backgroundImage: `url(${ringArt})`,
          backgroundSize: 'cover',
          animation: `${direction === 'ccw' ? 'clbSpinCCW' : 'clbSpinCW'} ${spin}s linear infinite`,
        }}
      />
      <span
        style={{
          position: 'absolute',
          inset: pad,
          borderRadius: '50%',
          overflow: 'hidden',
          background: faceBackground,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {children}
      </span>
    </span>
  );
}
